import { useState, useEffect } from "react";
import {
  CardContent,
  CardImage,
  CardImageSkeleton,
  CardName,
  CardSpecialty,
  CardInfoWrapper,
  CardLink,
} from "./styles";

const PractitionerCard = ({ practitioner, onPractitionerClick }) => {
  const [imageLoading, setImageLoading] = useState(true);
  const [imageError, setImageError] = useState(false);

  const imageSrc = practitioner.image;

  useEffect(() => {
    setImageLoading(true);
    setImageError(false);

    if (!imageSrc) {
      setImageLoading(false);
      setImageError(true);
      return;
    }

    const img = new Image();
    img.onload = () => {
      setImageLoading(false);
      setImageError(false);
    };
    img.onerror = () => {
      setImageLoading(false);
      setImageError(true);
    };
    img.src = imageSrc;
  }, [imageSrc]);

  // object-position chosen by the practitioner in the dashboard (falls back to
  // the styled default when unset).
  const avatarPosition = practitioner.avatarPosition;

  return (
    <CardContent>
      {imageLoading ? (
        <CardImageSkeleton variant="rectangular" animation="wave" />
      ) : !imageError ? (
        <CardImage
          src={imageSrc}
          alt={practitioner.name}
          style={avatarPosition ? { objectPosition: avatarPosition } : undefined}
        />
      ) : null}
      <CardLink
        className="card-link"
        onClick={() => onPractitionerClick(practitioner)}
      >
        Meet {practitioner?.userData?.firstName}
      </CardLink>
      <CardInfoWrapper>
        <CardName variant="h6">{practitioner.name}</CardName>
        <CardSpecialty variant="body2">{practitioner.specialty}</CardSpecialty>
      </CardInfoWrapper>
    </CardContent>
  );
};

export default PractitionerCard;
